import { mergeStyleSets, ITheme, getTheme } from '@fluentui/react';
const theme: ITheme = getTheme();

export const pageNotFoundStyles = mergeStyleSets({
    container: {
        padding: '60px 40px',
        backgroundColor: theme.palette.neutralLighter,
        borderRadius: '12px',
        margin: '40px 20px',
        border: `1px solid ${theme.palette.neutralQuaternary}`,
        boxShadow: theme.effects.elevation8,
        minHeight: '400px',
        maxWidth: '600px',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    
    icon: {
        fontSize: '48px',
        color: theme.palette.themePrimary,
        marginBottom: '10px'
    },
    
    errorCode: {
        fontSize: '72px',
        fontWeight: 'bold',
        color: theme.palette.neutralSecondary,
        marginBottom: '10px',
        lineHeight: '1'
    },
    
    title: {
        color: theme.palette.neutralPrimary,
        fontWeight: '600',
        marginBottom: '10px',
        textAlign: 'center'
    },
    
    message: {
        color: theme.palette.neutralSecondary,
        textAlign: 'center',
        maxWidth: '450px',
        lineHeight: '1.6',
        marginBottom: '20px'
    },
    
    buttonContainer: {
        marginTop: '20px'
    },
    
    button: {
        minWidth: '120px',
        height: '36px'
    }
});
